module.exports = __webpack_public_path__ + "static/media/myListing.832ed8b8.svg";